import React, { useState } from "react";
import Data_config from "./Data_config";
import "../Css/Test.css";
import worldcom_pic from "../images/worldcom_pic.svg";
import {Link} from 'react-router-dom'
function Test() {
  const [readMore1, setReadMore1] = useState(false);

  const extraContent1 = (
    <div className="content_container">
      <p className="extra-content text-justify">
        <br /> Murtaza is a young refugee from Afghanistan currently living in a
        refugee camp in Greece. He has been learning how to code with Social
        Hackers Academy. At the moment, h is making a refugee social networking
        site to promote communication.
        <br />
        <br />
        “Social Hackers Academy taught me how to code, but not only coding. They
        also taught me how to look at life differently and pursue a bigger goal.
        My goal in the future is to help young people, and this organization
        motivates me so that I can build a web application using the skills I
        learned from Social Hackers Academy,” he says.
        <br />
        <br />
        Murtaza adds that he wants “to give youth the motivation that they can
        use their skills.”
        <br />
        <br />
        “We can make this world a better place to live,” he adds.
        <br />
        <a
          className="active_section"
          href="https://socialhackersacademy.org/student/do-you-know-how-our-students-united-refugees-during-covid-19/?fbclid=IwAR2ZKLE-XtkqiCrIcy-tngEriHmPKms1JJsBEBn1nFLkIMu7Z-ZK39XjtQM"
        >
          More Here
        </a>
      </p>
      <hr style={{ paddingTop: "50px", borderTop: "1px solid black" }}></hr>
    </div>
  );

  const extraContent2 = (
    <div>
      <p className="extra-content text-justify">
        <br /> Bench Weightlifting is considered the sport of the strong. The
        History has however shown that the strength of the athlete must be
        accompanied by proper tactics and the guidance of a worthy coach. In her
        sport ‘Weightlifting on a bench, athletes compete from supine position
        (back) on a specially designed bench. The official assistants of an
        athlete give the bar to the competitor, at the height of the stretches
        in his hands. The athlete should complete the within two minutes attempt
        by making the following moves: lower the bar to chest, keep it for a
        short time still and in then push it upwards to the full extent of the
        arms. The races are organized for men and women who compete in specific
        categories, according to their body weight.
      </p>
      <hr style={{ paddingTop: "50px", borderTop: "1px solid black" }}></hr>
    </div>
  );

  const linkName1 = readMore1
    ? "Read less  "
    : " 1) Social Hackers Academy ... ";

  return (
    <div className="sepNav">
      <div className="row1">
        {Data_config.get_information.map((get_data) => {
          return (
            <div>
              <Link to="/" className="titleh1">
              <img src={worldcom_pic} alt="worldcom_pic" />
              </Link>

              <div className="row1">
                <div className="row1">
                  <div
                    className="history col-xs-10 col-sm-8 col-md-10"
                    style={{ paddingBottom: "100px" }}
                  >
                    <h1 className="H1_a">CREATED BY</h1>

                    <p className="text-justify">
                      {get_data.description}
                      <br />
                    </p>

                    <hr
                      style={{
                        paddingTop: "1px",
                        borderTop: "1px solid black",
                      }}
                    ></hr>
                  </div>
                </div>

                <div className="row1">
                  <div className="history col-xs-10 col-sm-10 col-md-10">
                    <h1 className="H1_a">Read More</h1>
                    <h3 className="h3_target">The Target:</h3>
                    <p className="text-justify">{get_data.discription1}</p>
                    <br />
                    <div className="App1">
                      <a
                        className="read-more-link"
                        onClick={() => {
                          setReadMore1(!readMore1);
                        }}
                      >
                        <h3>{linkName1}</h3>
                      </a>
                      {readMore1 && extraContent1}
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Test;
